// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CaesarСipher-content {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding: 0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
  width: auto;
}
.CaesarСipher-conteiner {
  display: grid;
  grid-template-rows: 5vw 1fr;
  align-items: start;
  height: 100%;
  width: 100%;
  min-width: 0;
}

.CaesarСipher-mainsubtitle {
  position: relative;
  left:50.5vw;
  font-family: "Amatic SC";
  font-size: 3vw;
}
.CaesarСipher-mainsubtitle.CaesarСipher--type2{
  left: 46.5vw;
}
.CaesarСipher-titleGame {
  display: grid;
  grid-template-columns: 20vw auto;
}

.CaesarСipher-Scene {
  display: flex;
  flex-direction: column;
  gap: 3vw;
  min-width: 0;
  min-height: 0;
  height: -moz-fit-content;
  height: fit-content;
}
.CaesarСipher-fullscreen {
  display: grid;
  height: 1.5vw;
  justify-self: end;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/CaesarСipher/styles/Caesar%D0%A1ipherApp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yDAAgE;EAChE;;oCAEkC;EAClC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["#CaesarСipher-content {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding: 0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n  width: auto;\n}\n.CaesarСipher-conteiner {\n  display: grid;\n  grid-template-rows: 5vw 1fr;\n  align-items: start;\n  height: 100%;\n  width: 100%;\n  min-width: 0;\n}\n\n.CaesarСipher-mainsubtitle {\n  position: relative;\n  left:50.5vw;\n  font-family: \"Amatic SC\";\n  font-size: 3vw;\n}\n.CaesarСipher-mainsubtitle.CaesarСipher--type2{\n  left: 46.5vw;\n}\n.CaesarСipher-titleGame {\n  display: grid;\n  grid-template-columns: 20vw auto;\n}\n\n.CaesarСipher-Scene {\n  display: flex;\n  flex-direction: column;\n  gap: 3vw;\n  min-width: 0;\n  min-height: 0;\n  height: fit-content;\n}\n.CaesarСipher-fullscreen {\n  display: grid;\n  height: 1.5vw;\n  justify-self: end;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
